import { render, staticRenderFns } from "./detail-cimbgroup.vue?vue&type=template&id=b070f66a&"
import script from "./detail-cimbgroup.vue?vue&type=script&lang=js&"
export * from "./detail-cimbgroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports